// removed by extract-text-webpack-plugin
module.exports = {"Labs":"Labs___1RDrg","h1":"h1___2gBAY","h2":"h2___1wfzs","h3":"h3___1ld7x","ul":"ul___2-f82","li":"li___1G1Jb","p":"p___2C3ZF"};


//////////////////
// WEBPACK FOOTER
// ./app/js/components/Labs/style.scss
// module id = 119
// module chunks = 0